import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const container = document.getElementById('root');

const root = ReactDOMClient.createRoot(container);

root.render(<App />);
